
import { Constants } from "@/constant/Constants";
import { Environment } from "@/data/Environment";
import { Integration } from "@/data/Integration";
import { Language } from "@/data/Language";
import { TestingParameters } from "@/data/TestingParameters";
import AbstractVue from "@/views/AbstractVue";
import { Game } from "./data/Game";
import { AppDataType } from "@/types";
import { generateNoCacheString, localStorageGetOrDefault } from '@/data/Utils';

export default class App extends AbstractVue {
  protected loaded = false;
  created(): void {
    this.$http.get("./data.json" + generateNoCacheString()).then((response) => {
      let data: AppDataType = response.data;
      let games: Game[] = [];

      for (let gameData of data[Constants.GAMES]) {
        games.push(new Game(gameData));
      }

      let environments: Environment[] = [];
      for (let environmentData of data[Constants.ENVIRONMENTS]) {
        environments.push(new Environment(environmentData));
      }

      let integrations: Integration[] = [];
      for (let integrationData of data[Constants.INTEGRATIONS]) {
        integrations.push(new Integration(integrationData));
      }

      let languages: Language[] = [];
      for (let languageData of data[Constants.LANGUAGES]) {
        languages.push(new Language(languageData));
      }

      let buildPrefixes: string[] = data[Constants.BUILD_PREFIXES];

      let currencies: string[] = data[Constants.CURRENCIES];
      let playModes: string[] = data[Constants.PLAY_MODES];

      this.store.state.games = games;
      this.store.state.environments = environments;
      this.store.state.integrations = integrations;
      this.store.state.languages = languages;
      this.store.state.currencies = currencies;
      this.store.state.playModes = playModes;
      this.store.state.buildPrefixes = buildPrefixes;

      this.store.state.parameters = new TestingParameters();
      this.parameters.environment = environments[0];
      this.parameters.integration = integrations[0];
      this.parameters.language = languages[0];
      this.parameters.currency = localStorageGetOrDefault("player_currency", currencies[0]);
      this.parameters.playMode = playModes[0];
      this.parameters.playerId = localStorageGetOrDefault("player_id", this.parameters.token);

      this.loaded = true;
    });
  }
}
